import { cn } from '@/lib/utils';

interface SpriteIconProps {
  src: string;
  col: number;
  row: number;
  cols: number;
  rows: number;
  size?: number;
  className?: string;
}

export function SpriteIcon({ src, col, row, cols, rows, size = 64, className }: SpriteIconProps) {
  // Calculate background position as percentage
  const xPercent = cols > 1 ? (col / (cols - 1)) * 100 : 0;
  const yPercent = rows > 1 ? (row / (rows - 1)) * 100 : 0;

  return (
    <div
      className={cn('bg-no-repeat overflow-hidden', className)}
      style={{
        width: size,
        height: size,
        backgroundImage: `url(${src})`,
        backgroundSize: `${cols * 100}% ${rows * 100}%`,
        backgroundPosition: `${xPercent}% ${yPercent}%`,
      }}
    />
  );
}
